import axios from 'axios';
import authHeader from "@/service/auth-header";

class ProviderService {

    searchProvidersByName(providerName) {
        return axios.get(`/api/provider/name/${providerName}`,{ headers: authHeader() })
    }

}

export default new ProviderService();
